export { firstDefined, getRegionCountryCode } from './helpers'
export { isKidsAccount } from './isKids'
export { getInvoiceFormDefaults, getAddressFormDefaults } from './formDefaults'
export {
  createStepValidationContext,
  getStepStatus,
  getErrorSections,
  hasAnyDataFor,
  isStepValid,
  type StepStatus,
  type StepValidationContext,
} from './stepValidation'
export {
  getPersonalDetailLines,
  getContactDetailLines,
  getAddressDetailLines,
  getInvoiceDetailLines,
} from './detailLines'
export { buildCustomerCreatePayload } from './buildCreatePayload'
export { getFlowSteps, getModalSteps } from './steps'
export {
  hasAnyInvoiceData,
  hasAnyInvoiceFormValues,
} from './invoice'
export {
  isKidsContactStepValid,
  isParentAuthComplete,
  clearParentAuth,
} from './parentAuth'
export type { ParentAuthStatus } from '../schemas'
export { isInvoiceRequired } from './stepValidation'
export type { CreateCustomerData, ParentData } from '../schemas'
